import { CHAIN_IDS } from '@/constants/chain';

import type { Price, Quote } from '@/utils/0x.types';

export const isSankeyRouteAvailable = (
  price: Price | Quote | undefined,
  chainId: number | undefined,
): price is Price | Quote =>
  !!price && 'route' in price && (chainId !== CHAIN_IDS.SOLANA || 'provider' in price);
